import customHeaders, { getSpace } from '../../common/headers';
import { useLocation, useParams } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { useState, useEffect, useRef } from 'react';
import { DropDownSelector, TableBox, Tabs } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './SupplyList.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useResponseHandler } from '../../common/auth';
import { FilterArticles } from '../../components/FilterArticles/FilterArticles';
import { options_prop_mp } from '../../common/globalVariables';
import { useSavedFilters } from '../../common/useSavedFilters';

const TABS = [
  { label: 'Список поставок', value: 'supply_list' },
  { label: 'Товары в поставке', value: 'supply_products' }
];

const SupplyList = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'supply-list');
  const requestControllerRef = useRef(new RequestController())
  const location = useLocation();

  const { handleTableResponse, handleRequestError } = useResponseHandler();

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  // Флаг для отслеживания первой инициализации из URL
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  const activeTab = useParams()['*'];
  const [pageValue, setPageValue] = useState(TABS[0].value);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)

  // таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs;
  const [filterValue, setFilterValue] = useState([]);

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Инициализация фильтров из URL параметров при первом рендере
  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp);
        if (urlParams.api) setSelectedApi(urlParams.api);
        if (urlParams.category) setSelectedCategory(urlParams.category);
        if (urlParams.brand) setSelectedBrand(urlParams.brand);
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMarketplace,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand
    })
  }, [isReady]);

  // Таблицы
  const fetchTableData = (params, abortController = new AbortController()) => {

    setLoading(true)
    let sort;
    let filters;

    if (params) {
      [sort, filters] = params;
    }

    let url = `https://apps1.ecomru.ru:4450/api/v1/supply/table/${pageValue}${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const body = JSON.stringify({
      mp_id_list: getValueMultiFilter(selectedMarketplace),
      api_id_list: getValueMultiFilter(selectedApi),
      brand_id_list: getValueMultiFilter(selectedBrand),
      category_id_list: getValueMultiFilter(selectedBrand),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      offer_id_list: filterValue,
      filters,
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((table) => setTable(table))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return
        setLoading(false)
      })
  };

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalApi,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      selectedShop: selectedMarketplace,
      selectedBrand,
      selectedCategory,
      filter: 'api_id '
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter()
  }, [isFilterRequest, apiPage, apiQuery]);

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCategory,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      filter: 'category'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter()
  }, [isFilterRequest, categoryPage, categoryQuery]);

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalBrand,
      page: brandPage,
      set: setBrandData,
      searchParam: brandQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      selectedCategory,
      filter: 'brand'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter()
  }, [isFilterRequest, brandPage, brandQuery]);

  useEffect(() => {
    paginatorRef.current.reset()
    paginatorRef.current.setTotal(0)
  }, [pageValue]);

  useEffect(() => {
    if (!isReady) return;
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [
    pageValue,
    isTableRequest,
    filterValue
  ]);

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);


  return (
    <div className="supply-list">
      <TitlePage
        title='Список поставок'
      />

      <FilterContainer
        loading={isSaved}
        saveFilters={saveFilters}
        clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
        onReset={(e) => {
          setSelectedMarketplace([])
          setSelectedApi([]);
          setSelectedCategory([]);
          setSelectedBrand([]);
          updateURL({
            mp: null,
            api: null,
            category: null,
            brand: null,
          });
          setIsFilterRequest(!isFilterRequest);
          setIsTableRequest(!isTableRequest)
        }}
      >
        <DropDownSelector
          options_prop={options_prop_mp}
          state={selectedMarketplace}
          setState={(e) => setSelectedMarketplace(e)}
          placeholder="Площадка"
          total={options_prop_mp?.length}
          multi
          onBlur={e => {
            updateURL({ mp: selectedMarketplace });
            apiFilter()
            brandFilter()
            categoryFilter()
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={apiData}
          state={selectedApi}
          setState={setSelectedApi}
          placeholder="Магазин"
          total={totalApi}
          multi
          fetchCallback={setApiPage}
          setInputChange={setApiQuery}
          onBlur={e => {
            updateURL({ api: selectedApi });
            brandFilter()
            categoryFilter()
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={categoryData}
          state={selectedCategory}
          setState={setSelectedCategory}
          placeholder="Категория"
          total={totalCategory}
          multi
          fetchCallback={setCategoryPage}
          setInputChange={setCategoryQuery}
          onBlur={e => {
            updateURL({ category: selectedCategory });
            brandFilter()
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          options_prop={brandData}
          state={selectedBrand}
          setState={setSelectedBrand}
          placeholder="Бренд"
          total={totalBrand}
          multi
          fetchCallback={setBrandPage}
          setInputChange={setBrandQuery}
          onBlur={e => {
            updateURL({ brand: selectedBrand });
            setIsTableRequest(!isTableRequest)
          }}
        />
      </FilterContainer>

      <Tabs
        tabs={TABS}
        pageValue={pageValue}
        query={location?.search}
      />

      <TableBox
        {...tableProps}
        ref={paginatorRef}
        paginator={true}
        fetchCallback={fetchTableData}
        child={
          <FilterArticles
            filterValue={filterValue}
            setFilterValue={setFilterValue}
          />
        }
      />
    </div>
  );
};

export { SupplyList };
